export const StripeOptions = {
    classes: {
        base: 'stripe-element',
        focus: 'stripe-element--focus',
        invalid: 'stripe-element--invalid',
        complete: 'stripe-element--complete'
    },
    style: {
        base: {
            color: '#19181c',
            fontFamily: 'Asap',
            fontSize: '17px',
            fontWeight: 400,
            '::placeholder': {
                color: 'rgba(136, 139, 148, 0.5)',
            },
        },
        invalid: {
            color: '#19181c'
        },
        focus: {
            color: '#19181c'
        },
        complete: {
            color: '#19181c'
        }
    },
};

export const CardCvcOptions = {
    ...StripeOptions,
    placeholder: '***',
    hideCode: true
};

export const Stripe = window.Stripe(process.env.STRIPE_API_KEY);

export const Elements = Stripe.elements({fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Asap:400' }]});


// WEBPACK FOOTER //
// ./src/constants/stripe.js